import styled, { css } from 'styled-components';

// Import styles
import { customResponsive, flex, size } from 'components/styles';

export const Wrapper = styled.div`
	position: relative;
	${flex()}
	column-gap: 2rem;

	${customResponsive(
		size.medium,
		css`
			svg {
				width: 3.3rem;
			}
		`
	)}
`;
